// src/utils/messages.js
export const showMessage = (message) => {
    const messageDiv = document.getElementById('messages');
    if (messageDiv) {
      messageDiv.textContent = message;
      messageDiv.style.display = 'block';
    } else {
      console.error('Message div not found');
    }
  };
  